// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";  // Add this import
import ar from "./locales/ar.json";  // Add this import

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },  // Add Spanish resources
      ar: { translation: ar },  // Add Arabic resources
    },
    supportedLngs: ["en", "fr", "es", "ar"],  // Explicitly list supported languages
    fallbackLng: "en",
    lng: "en", // default language
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;